module.exports = __webpack_public_path__ + "img/Deathknight-bloodelf-m-70.9b0156f7.gif";